import React from "react";
import { Grid, Label, Progress, Segment } from "semantic-ui-react";
import { ProgressDisplayStatus } from "../management/tabs/subscription/types";

type SubscriptionFieldProps = {
  /** Value to display based on total. */
  value: number;
  /** Total amount. */
  total: number;
  /** Is total amount infinite? */
  infiniteTotal: boolean;
  /** Progress display: [value, ratio, percent]. */
  progress?: boolean | "value" | "percent" | "ratio";
  /** Progress layer. */
  label: string;
};

type SubscriptionFieldState = {
  progressDisplayTypeStatues: ProgressDisplayStatus;
  percentage: number;
};

/**
 * Subscription Field used to display amount of object use.
 */
class SubscriptionField extends React.PureComponent<
  SubscriptionFieldProps,
  SubscriptionFieldState
> {
  constructor(props: SubscriptionFieldProps) {
    super(props);
    const percentage = this._calculatePercentage(props.value, props.total, props.infiniteTotal);
    this.state = {
      progressDisplayTypeStatues: this._selectProgressDisplayType(percentage),
      percentage: percentage
    };
  }

  /**
   * Calculate percentage to process on Progress bar
   *
   * @param {Number} value            - Value
   * @param {Number} total            - Total
   * @param {Boolean} infiniteTotal   - Is total an infinite value?
   * @return {number}                 - Percentage
   * @private
   */
  _calculatePercentage = (value: number, total: number, infiniteTotal = false) => {
    if (infiniteTotal) return 0;
    if (total === 0) return 100;
    if (value !== 0) return Math.floor((value / total) * 100);
    return 0;
  };

  /**
   * Selects Progress bar display type based on progress percentage.
   *
   * @param {Number} percentage   - Progress percentage.
   * @returns                     - Progress display type status.
   * @private
   */
  _selectProgressDisplayType = (percentage: number) => {
    const status = {
      success: false,
      warning: false,
      error: false
    };
    if (percentage < 75) {
      status.success = true;
    } else if (percentage < 100) {
      status.warning = true;
    } else {
      status.error = true;
    }
    return status;
  };

  render() {
    return (
      <Grid.Column>
        <Segment>
          <Label attached="top left">{this.props.label + ":"}</Label>
          <Progress
            percent={this.state.percentage}
            progress={this.props.progress ? this.props.progress : false}
            success={this.state.progressDisplayTypeStatues["success"]}
            warning={this.state.progressDisplayTypeStatues["warning"]}
            error={this.state.progressDisplayTypeStatues["error"]}
          />
        </Segment>
      </Grid.Column>
    );
  }
}
export default SubscriptionField;
